import { render, staticRenderFns } from "./WaggonInfoHeaderAdd.component.vue?vue&type=template&id=8ece7ba8&"
import script from "./WaggonInfoHeaderAdd.component.vue?vue&type=script&lang=js&"
export * from "./WaggonInfoHeaderAdd.component.vue?vue&type=script&lang=js&"
import style0 from "./WaggonInfoHeaderAdd.component.vue?vue&type=style&index=0&id=8ece7ba8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports